import { defineStore } from "pinia";

const breakpoints = {
  "2xl": 1536,
  xl: 1280,
  lg: 1024,
  md: 768,
  sm: 640,
};

const breakpointsSizes = Object.keys(breakpoints);
const breakpointsPixels = Object.values(breakpoints);

type Breakpoint = keyof typeof breakpoints | undefined;

let isTracking = false;
let currentBreakpoint: Breakpoint;
let lastBreakpoint: Breakpoint;

export const useBreakpointStore = defineStore({
  id: "breakpoint",
  state: () => {
    return {
      screenWidth: 0,
    };
  },
  actions: {
    setCurrentBreakpoint() {
      const width = window.innerWidth;
      this.screenWidth = width;

      const pointIndex = breakpointsPixels.findIndex((pixels) => width >= pixels);
      currentBreakpoint = <Breakpoint>breakpointsSizes[pointIndex];
    },
    startScreenSizeListener() {
      if (isTracking) {
        return;
      }

      this.setCurrentBreakpoint();

      const onBreakpoint = new CustomEvent("breakpoint");
      window.addEventListener("resize", () => {
        this.setCurrentBreakpoint();

        if (currentBreakpoint !== lastBreakpoint) {
          window.dispatchEvent(onBreakpoint);
        }

        lastBreakpoint = currentBreakpoint;
      });
      isTracking = true;
    },
    captureBreakpoint(callback: (breakpoint: Breakpoint) => any) {
      callback(currentBreakpoint);
      window.addEventListener("breakpoint", (e: any) => {
        callback(currentBreakpoint);
      });
    },
  },
});
